<template>
  <div class="sign">
    <div class="sign-item">
      <ul>
        <li>
          <div class="sign-list">
            <strong>单号信息</strong>
          </div>
          <div class="sign-list">
            <p>单号：{{ info.trackNumber }}</p>
            <p>箱数：{{ info.boxCount }}</p>
          </div>
          <div class="sign-list">
            <p>总重量：{{ info.totalWeight }}</p>
            <p>总体积：{{ info.totalVolume }}</p>
          </div>
          <span v-if="info.bussbusinessType != 2">
            <div class="sign-list">
              <strong>产品信息</strong>
            </div>
            <div class="sign-list">
              <p>SKU：{{ info.sku }}</p>
            </div>
          </span>
          <div class="sign-list">
            <p v-if="info.bussbusinessType != 2">数量：{{ info.totalQty }}</p>
            <p style="white-space: nowrap">
              <span>{{
                info.bussbusinessType == 2 ? "送货箱数：" : "送货数量："
              }}</span
              ><input
                type="number"
                v-model="deliveryQty"
                @change="inputNumChange('deliveryQty')"
                maxlength="16"
                class="btn-num"
              />
            </p>
          </div>
          <div class="sign-list">
            <strong>送货地址</strong>
          </div>
          <div class="sign-list">
            <p>{{ info.address }}<br />{{ info.contacter }} {{ info.phone }}</p>
          </div>
        </li>
      </ul>
    </div>
    <van-tabs
      line-width="50%"
      line-height="2px"
      color="#1989fa"
      @click="tabClick"
    >
      <van-tab title="车辆派送">
        <div>
          <van-form validate-first @submit="submit" label-align="right">
            <!-- 通过 validator 进行函数校验 -->
            <van-field
              v-model="submitData1.expectedTime"
              name="expectedTime"
              label="送货日期："
              :readonly="true"
              placeholder="请选择送货日期"
              @click="carTimeClick"
              :rules="[{ required: true }]"
            />
            <span class="tipSpan">
              <van-field
                readonly
                clickable
                name="picker"
                :value="selectValue"
                :rules="[{ required: true }]"
                label="送货时间："
                placeholder="请选择送货时间"
                @click="showSelectPickerFn(1)"
              >
                <template #button v-if="selectValue == '19:00 至 21:00'">
                  <span>该时段为加班时间，会收取加班费用</span>
                </template>
              </van-field>
            </span>
            <van-field
              v-model="submitData1.driverName"
              name="driverName"
              label="司机："
              placeholder="请输入司机"
              maxlength="50"
              :formatter="relationNumberFmt"
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="submitData1.driverPhone"
              name="driverPhone"
              label="司机电话："
              placeholder="请输入司机电话号码"
              maxlength="20"
              type="number"
              :formatter="phoneFmt"
              :rules="[
                {
                  required: true,
                  validator: driverPhoneValid,
                  message: '请输入正确电话号码',
                },
              ]"
            />
            <van-field
              v-model="submitData1.driverCarNumber"
              name="driverCarNumber"
              label="车牌："
              placeholder="请输入车牌"
              maxlength="20"
              :formatter="carNumberFmt"
              :rules="[
                {
                  required: true,
                  validator: carValid,
                  message: '请输入正确车牌',
                },
              ]"
            >
              <template #input>
                <span class="driverCarSpan">
                  <LicensePlate
                    v-model="submitData1.driverCarNumber"
                    @change="changeCarNumber"
                  >
                  </LicensePlate>
                </span>
              </template>
            </van-field>
            <van-field
              v-model="submitData1.bookingUser"
              name="bookingUser"
              label="预约人："
              placeholder="请输入预约人"
              maxlength="50"
              :formatter="relationNumberFmt"
              :rules="[{ required: true }]"
            >
              <template #button>
                <van-checkbox
                  @change="changeCheck"
                  v-model="checked"
                  shape="square"
                  >与司机一致</van-checkbox
                >
              </template>
            </van-field>

            <van-field
              v-model="submitData1.bookingPhone"
              name="bookingPhone"
              label="预约电话："
              placeholder="请输入预约电话号码"
              maxlength="20"
              type="number"
              :formatter="phoneFmt"
              :rules="[
                {
                  required: true,
                  validator: driverPhoneValid,
                  message: '请输入正确的电话号码',
                },
              ]"
            />
            <van-field
              v-model="submitData1.checkCode"
              center
              clearable
              name="checkCode"
              label="验证码："
              placeholder="请输入短信验证码"
              maxlength="4"
              :formatter="relationNumberFmt"
              :rules="[{ required: true }]"
            >
              <template #button>
                <van-button
                  size="small"
                  type="info"
                  :color="isSendCode1 ? '#c1c1c1' : '#1989fa'"
                  @click="sendCode"
                  native-type="button"
                  >获取验证码{{
                    isSendCode1 ? `(${minutes1}s)` : ""
                  }}</van-button
                >
              </template>
            </van-field>
            <div style="margin: 16px">
              <van-button block type="info" native-type="submit"
                >提交预约</van-button
              >
            </div>
          </van-form>
        </div>
      </van-tab>
      <van-tab title="快递派送">
        <div class="sign-photo-cpntent">
          <div class="sign-photo-box">
            <van-form validate-first @submit="submit" label-align="right">
              <van-field
                v-model="submitData2.expectedTime"
                name="expectedTime"
                label="送货日期："
                :readonly="true"
                placeholder="请选择送货日期"
                @click="deliveryTimeClick"
                :rules="[{ required: true }]"
              />
              <span class="tipSpan">
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="selectValue"
                  :rules="[{ required: true }]"
                  label="送货时间："
                  placeholder="请选择送货时间"
                  @click="showSelectPickerFn(2)"
                >
                  <template #button v-if="selectValue == '19:00 至 21:00'">
                    <span>该时段为加班时间，会收取加班费用</span>
                  </template>
                </van-field>
              </span>
              <van-field
                v-model="submitData2.logisticsCompany"
                name="validator"
                label="快递公司："
                placeholder="请输入快递公司"
                maxlength="100"
                :formatter="relationNumberFmt"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="submitData2.logisticsNumber"
                name="validator"
                label="物流单号："
                placeholder="请输入物流单号"
                maxlength="50"
                :formatter="relationNumberFmt"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="submitData2.bookingUser"
                name="validator"
                label="预约人："
                placeholder="请输入预约人"
                maxlength="50"
                :formatter="relationNumberFmt"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="submitData2.bookingPhone"
                name="validator"
                label="预约电话："
                type="number"
                placeholder="请输入预约电话"
                maxlength="20"
                :formatter="phoneFmt"
                :rules="[
                  {
                    required: true,
                    validator: driverPhoneValid,
                    message: '请输入正确的电话',
                  },
                ]"
              />
              <van-field
                v-model="submitData2.checkCode"
                center
                clearable
                label="验证码："
                placeholder="请输入短信验证码"
                maxlength="4"
                :formatter="relationNumberFmt"
                :rules="[{ required: true }]"
              >
                <template #button>
                  <van-button
                    size="small"
                    type="info"
                    :color="isSendCode1 ? '#c1c1c1' : '#1989fa'"
                    @click="sendCode"
                    native-type="button"
                    >获取验证码{{
                      isSendCode1 ? `(${minutes1}s)` : ""
                    }}</van-button
                  >
                </template>
              </van-field>
              <div style="margin: 16px">
                <van-button block type="info" native-type="submit"
                  >提交预约</van-button
                >
              </div>
            </van-form>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <van-calendar
      v-model="show"
      ref="calendar"
      title="选择日期"
      @confirm="onConfirm"
      :show-confirm="false"
      :style="{ height: '500px' }"
      :show-subtitle="true"
      @month-show="monthShow"
      :formatter="formatterDate"
    />
    <van-popup
      v-model="showSelectPicker"
      position="bottom"
      class="van_pop_main"
    >
      <van-picker
        confirm-button-text="确定"
        cancel-button-text="取消"
        show-toolbar
        :columns="selectColumns"
        @confirm="onSelectConfirm"
        @cancel="showSelectPicker = false"
      />
    </van-popup>
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      :lazy-render="false"
    >
      <van-picker
        show-toolbar
        title="请选择预约时间"
        :columns="columns"
        confirm-button-text="确定"
        cancel-button-text="取消"
        :item-height="40"
        :visible-item-count="6"
        @confirm="onPickerConfirm"
        @cancel="showPicker = false"
        @change="onPickerChange"
        ref="pickerTime"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Picker,
  Popup,
  Checkbox,
  Field,
  DropdownMenu,
  DropdownItem,
  Empty,
  List,
  PullRefresh,
  cell,
  Toast,
  Loading,
  Form,
  Tabs,
  Tab,
  Button,
  DatetimePicker,
  Calendar,
} from "vant";
import { mapState } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { isMobile, isCarPlate } from "util/validate";
import {
  addBookingDelivery,
  sendCode,
  GetBookingPro,
  getBookHoliday,
} from "@/api/mobile_Reserve/mobileReserve_api";

let timeId1 = null;
let timeId2 = null;
let timeOutId1 = null;
let timeOutId2 = null;

export default {
  data() {
    return {
      holidayList: [],
      selectValue: "",
      selectColumns: [
        // {
        //     text:`
        //         <div>
        //             <div>9:00 至 10:30</div>
        //             <div class="progressBarMain">
        //                 <div class="progressBar" style="width:80%"></div>
        //             </div>
        //         </div>
        //     `,
        //     value:'9:00 至 10:30',
        // },
        // {
        //     text:'10:30 至 12:00',
        //     value:'10:30 至 12:00'
        // },
        // '9:00 至 10:30',
        // '10:30 至 12:00',
        // '14:00 至 16:30',
        // '16:00 至 18:00',
        // '19:00 至 21:00'
      ],
      showSelectPicker: false,
      checked: false,
      list: [],
      loading: false,
      startSearch: false,
      info: {},
      submitData1: {},
      submitData2: {},
      show: false,
      isReadonlyTime: false,
      showPicker: false,
      isToDay: false,
      isSendCode1: false,
      minutes1: 60,
      saveCode1: "",
      deliveryQty: 0,
      deliveryType: 1, // 1车辆派送2快递派送
      bussbusinessType: 1, //1中转2集货
      warehouseID: 0,
      orgID: 0,
    };
  },

  components: {
    [Icon.name]: Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Picker.name]: Picker,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [cell.name]: cell,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [Calendar.name]: Calendar,
  },
  computed: {
    columns: function () {
      let h1 = new Date().getHours(),
        m1 = new Date().getMinutes(),
        h2 = new Date().getHours(),
        m2 = new Date().getMinutes();

      let h1Arr, m1Arr, h2Arr, m2Arr;
      if (this.isToDay) {
        // 如果日期是当天
        h1Arr = this.generateArr(h1, 24, "h");
        m1Arr = this.generateArr(m1, 60, "m");
        h2Arr = this.generateArr(h2, 24, "h");
        m2Arr = this.generateArr(m2, 60, "m");
      } else {
        // 如果日期不是当天
        h1Arr = this.generateArr(0, 24, "h");
        m1Arr = this.generateArr(0, 60, "m");
        h2Arr = this.generateArr(0, 24, "h");
        m2Arr = this.generateArr(0, 60, "m");
      }

      let columns = [
        {
          values: h1Arr,
          defaultIndex: 0,
        },
        {
          values: m1Arr,
          defaultIndex: 0,
        },
        {
          values: ["-"],
          defaultIndex: 0,
        },
        {
          values: h2Arr,
          defaultIndex: 0,
        },
        {
          values: m2Arr,
          defaultIndex: 0,
        },
      ];

      return columns;
    },
  },
  watch: {
    minutes1(n) {
      if (n === 0) {
        this.isSendCode1 = false;
        this.minutes1 = 60;
        clearInterval(timeId1);
      }
    },
    "submitData2.bookingPhone"(n) {
      this.$set(this.submitData1, "bookingPhone", n);
    },
    "submitData1.bookingPhone"(n) {
      this.$set(this.submitData2, "bookingPhone", n);
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    formatterDate(day) {
      this.holidayList.forEach((range) => {
        const startDate = new Date(range.start).setHours(0, 0, 0, 0);
        const endDate = new Date(range.end).setHours(0, 0, 0, 0);

        // 检查日期是否在区间内
        if (day.date >= startDate && day.date <= endDate) {
          day.topInfo = range.text;
          day.type = "disabled";
        }
      });
      return day;
    },
    showSelectPickerFn(num) {
      if (num === 1) {
        if (!this.submitData1.expectedTime) {
          Toast("请先选择送货日期！");
          return;
        }
        this.showSelectPicker = true;
      } else {
        if (!this.submitData2.expectedTime) {
          Toast("请先选择送货日期！");
          return;
        }
        this.showSelectPicker = true;
      }
    },
    init() {
      this.info = this.$route.query;
      this.deliveryQty = this.info.totalQty;
      this.bussbusinessType = this.info.bussbusinessType;
      this.orgID = this.info.orgID;
      this.warehouseID = this.info.warehouseID;
      this.getBookHoliday();
    },
    getBookHoliday() {
      const { startDate } = new Date().toLocaleDateString();
      const data = {
        startDate,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getBookHoliday(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.holidayList = res.response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    onSelectConfirm(value) {
      this.selectValue = value.value;
      this.showSelectPicker = false;
    },
    changeCheck(data) {
      if (data) {
        this.$set(this.submitData1, "bookingUser", this.submitData1.driverName);
        this.$set(
          this.submitData1,
          "bookingPhone",
          this.submitData1.driverPhone
        );
      }
    },
    sendCode() {
      const that = this;
      const { bookingPhone } =
        that.deliveryType === 1 ? this.submitData1 : this.submitData2;

      if (that.isSendCode1) return;
      if (!bookingPhone) return Toast("请输入预约电话");
      if (!isMobile(bookingPhone)) return Toast("请输入正确的预约电话");

      Toast.loading({
        message: "短信发送中...",
        forbidClick: true,
      });

      const data = {
        phone: bookingPhone,
      };

      sendCode(data).then((res) => {
        Toast.clear();
        if (res.status === 200 && res.success) {
          const { response } = res;

          Toast(res.msg);

          this.isSendCode1 = true;
          this.saveCode1 = response;

          timeId1 = setInterval(function () {
            that.minutes1--;
          }, 1000);
          clearInterval(timeOutId1);
          timeOutId1 = setTimeout(function () {
            that.saveCode1 = "";
          }, 600000);
        } else {
          this.isSendCode1 = false;
          Toast.fail(res.msg);
        }
      });
    },

    carTimeClick() {
      this.show = true;
    },

    deliveryTimeClick() {
      this.show = true;
    },

    submit() {
      const that = this;
      if (!this.deliveryQty) return Toast("请输入送货数量");

      if (this.saveCode1 != this[`submitData${this.deliveryType}`].checkCode)
        return Toast("验证码错误，请重新输入");

      // if(this.deliveryType === 1 ? this.submitData1.expectedTime:this.submitData2.expectedTime){
      //     if(!this[`submitData${this.deliveryType}`].expectedTime.includes(' ')){
      //         return Toast('请选择完整时间')
      //     }
      // }

      const { trackNumber, sku } = this.info;
      let expectedTimeData = this.selectValue.replaceAll("至", "-");
      const obj = {
        deliveryType: this.deliveryType,
        trackNumber,
        skuCode: sku,
        deliveryQty: this.deliveryQty,
        bussbusinessType: this.bussbusinessType,
        orgID: this.orgID,
        warehouseID: this.warehouseID,
        expectedTime: expectedTimeData.replaceAll(" ", ""),
        estimatedDate:
          this.deliveryType === 1
            ? this.submitData1.expectedTime
            : this.submitData2.expectedTime,
      };
      const data = Object.assign(
        {},
        this.deliveryType === 1 ? this.submitData1 : this.submitData2,
        obj
      );
      Toast.loading({
        message: "预约中...",
        forbidClick: true,
      });

      addBookingDelivery(data).then((res) => {
        Toast.clear();
        if (res.status === 200 && res.success) {
          this.saveCode1 = "";
          this.$set(this.submitData1, "checkCode", "");

          Toast(res.msg);

          setTimeout(function () {
            that.$router.replace({ path: "/mobile/appointmentDelivery" });
          }, 1500);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    formatDate(date) {
      let m = date.getMonth() + 1;
      let d = date.getDate();
      m = m > 9 ? m : `0${m}`;
      d = d > 9 ? d : `0${d}`;
      return `${date.getFullYear()}-${m}-${d}`;
    },
    getSelectColumns(date) {
      GetBookingPro({ estimatedDate: date }).then((res) => {
        if (res.status === 200 && res.success) {
          let newColumns = res.response.map((item) => {
            let proportion = item.proportion * 100;
            let color =
              proportion == 100
                ? "#f5a596"
                : proportion > 50
                ? "#f100f1"
                : "#b1e47c";
            let status =
              proportion == 100 ? "约满" : proportion > 50 ? "紧张" : "宽松";
            return {
              text: `
                                <div style='display:flex'>
                                    <div style='margin-right: 30px;width: 110px;'>
                                        <div>${
                                          item.expectedTime.split("-")[0]
                                        } 至 ${
                item.expectedTime.split("-")[1]
              }</div>
                                        <div class="progressBarMain">
                                            <div class="progressBar" style="width:${proportion}%;background: ${color}"></div>
                                        </div>
                                    </div>
                                    <div style='color:${color}'>${status}</div>
                                </div>
                            `,
              value: `${item.expectedTime.split("-")[0]} 至 ${
                item.expectedTime.split("-")[1]
              }`,
            };
          });
          this.$set(this, "selectColumns", newColumns);
        } else {
          this.$set(this, "selectColumns", []);
        }
      });
    },
    onConfirm(date) {
      this.show = false;
      // this.showPicker = true;
      this.isToDay =
        new Date().toDateString() ===
        new Date(this.formatDate(date).replace(/\-/g, "/")).toDateString();
      this.deliveryType === 1
        ? this.$set(this.submitData1, "expectedTime", this.formatDate(date))
        : this.$set(this.submitData2, "expectedTime", this.formatDate(date));
      this.getSelectColumns(this.formatDate(date));
      if (this.isToDay) {
        this.$refs.pickerTime.setColumnValue(0, new Date().getHours());
        this.$refs.pickerTime.setColumnValue(1, new Date().getMinutes());
        this.$refs.pickerTime.setColumnValue(3, new Date().getHours());
        this.$refs.pickerTime.setColumnValue(4, new Date().getMinutes());
      } else {
        this.$refs.pickerTime.setColumnValue(0, "00");
        this.$refs.pickerTime.setColumnValue(1, "00");
        this.$refs.pickerTime.setColumnValue(3, "00");
        this.$refs.pickerTime.setColumnValue(4, "00");
      }
    },

    onPickerConfirm(date) {
      const str = `${date[0]}:${date[1]}-${date[3]}:${date[4]}`;
      const fn = (n) => {
        return Number(date[n]);
      };
      if (fn(0) < fn(3) || (fn(0) === fn(3) && fn(1) < fn(4))) {
        this.$set(
          this[`submitData${this.deliveryType}`],
          "expectedTime",
          `${this[`submitData${this.deliveryType}`].expectedTime} ${str}`
        );
        // this.showPicker = false
      } else {
        Toast("开始时间不能大于或等于结束时间");
      }
    },

    onPickerChange(Picker, allVal, curIndex) {
      if (curIndex === 0) {
        if (Picker.getColumnIndex(curIndex) !== 0) {
          Picker.setColumnValues(1, this.generateArr(0, 60, "m"));
          Picker.setColumnValue(1, "00");
        } else {
          Picker.setColumnValue(1, "00");
          this.isToDay &&
            Picker.setColumnValues(
              1,
              this.generateArr(new Date().getMinutes(), 60, "m")
            );
        }
      }
      if (curIndex === 3) {
        if (Picker.getColumnIndex(curIndex) !== 0) {
          Picker.setColumnValues(4, this.generateArr(0, 60, "m"));
          Picker.setColumnValue(4, "00");
        } else {
          Picker.setColumnValue(4, "00");
          this.isToDay &&
            Picker.setColumnValues(
              4,
              this.generateArr(new Date().getMinutes(), 60, "m")
            );
        }
      }
    },

    monthShow(val) {
      const d = new Date(val.date);

      // 处理vant-ui 日历副标题显示问题
      const c = document.getElementsByClassName("van-calendar__weekdays")[0];
      c.innerHTML = "";
      c.innerHTML =
        '<span class="van-calendar__weekday">日</span><span class="van-calendar__weekday">一</span><span class="van-calendar__weekday">二</span><span class="van-calendar__weekday">三</span><span class="van-calendar__weekday">四</span><span class="van-calendar__weekday">五</span><span class="van-calendar__weekday">六</span>';

      const t = document.getElementsByClassName(
        "van-calendar__header-subtitle"
      )[0];
      t.innerHTML = `${d.getFullYear()}年`;
    },

    relationNumberFmt(v) {
      return v.trim();
    },

    carNumberFmt(v) {
      return v.trim().toUpperCase();
    },

    phoneFmt(v) {
      return v.trim().replace(/\-/g, "");
    },

    validator(val) {
      return /1\d{10}/.test(val);
    },

    driverPhoneValid(val) {
      return isMobile(val);
    },

    carValid(val) {
      return isCarPlate(val);
    },

    generateArr(cur, total, type) {
      let arr = [];
      for (let i = cur; i < total; i++) {
        i = i > 9 ? i : `0${i}`;
        // const n = type === 'h' ? '时':'分'
        // arr.push(`${i}${n}`);
        arr.push(i);
      }
      return arr;
    },

    inputNumChange(field) {
      let str = String(this[field]);
      if (str.length > 9) {
        str = 0;
      }
      let num = Number(str);
      // const {totalQty} = this.info
      // if(num > totalQty){
      //     Toast('送货数量大于可收货数量')
      //     num = Number(totalQty)
      // }else
      if (num < 0) {
        Toast("请输入正整数");
        num = 0;
      }
      this[field] = parseInt(num);
    },
    changeCarNumber() {},
    tabClick(n, t) {
      this.selectValue = "";
      if (n === 1) {
        if (this.submitData2.expectedTime) {
          if (this.submitData2.expectedTime.includes(" ")) {
            let arrs = this.submitData2.expectedTime.split(" ");
            this.$refs.calendar.reset(new Date(arrs[0]));
          } else {
            this.$refs.calendar.reset(new Date(this.submitData2.expectedTime));
          }
        } else {
          this.$refs.calendar.reset(new Date());
        }
        this.$nextTick(function () {
          this.deliveryType = 2;
        });
      } else {
        if (this.submitData1.expectedTime) {
          if (this.submitData1.expectedTime.includes(" ")) {
            const { expectedTime } = this.submitData1;
            let arrw = expectedTime.split(" ");

            this.$refs.calendar.reset(new Date(arrw[0]));
          } else {
            this.$refs.calendar.reset(new Date(this.submitData1.expectedTime));
          }
        } else {
          this.$refs.calendar.reset(new Date());
        }
        this.$nextTick(function () {
          this.deliveryType = 1;
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
// ::v-deep .van-cell {
// 	border: 1px solid #adadad;
// 	margin-bottom: 7px;
// 	padding: 5px 10px;
// }
.sign {
  // background-color: #fbf9fe;
}

.van_pop_main {
  ::v-deep .progressBarMain {
    height: 4px;
    background: #fff;
    border: 1px solid #f5a596;
    border-radius: 4px;
  }

  ::v-deep .progressBar {
    background: #b1e47c;
    height: 4px;
  }
}

.sign-item {
  // border-top: 1px solid #ccc;
  padding: 5px;
}

.sign-item li {
  // border-bottom: 1px solid #ccc;
  // background-color: #fbf9fe;
  padding: 3px 10px;
  font-size: 12px;
  box-shadow: 0px 0px 5px 0px #cccccc;
}

.sign-list {
  display: flex;
  margin: 5px 0;

  p {
    flex: 1;
    word-break: break-all;
    margin: 0;
  }
}

.btn-num {
  width: 40%;
  margin-left: 2px;
}

.tipSpan {
  ::v-deep .van-field__button {
    position: absolute;
    bottom: -14px;
    font-size: 10px;
    color: red;
    padding-left: 0;
  }
}

.driverCarSpan {
  display: block;
  width: 100%;

  > div {
    width: 100%;

    > div {
      width: 100%;
    }
  }

  ::v-deep .input_container .input_box {
    margin-left: 4px !important;
    height: 30px !important;
  }

  ::v-deep .input_container .input_box:first-child {
    margin-left: 0px !important;
  }

  ::v-deep .button {
    padding: 4px 0 !important;
  }
}
</style>